import { gql, QueryHookOptions, useQuery } from "@apollo/client";

export interface Municipality {
  agsKey?: string | null;
  name: string;
  taxRate: number;
  sourceReferenceDate?: Date | string | null;
}
export interface MunicipalitiesQueryResult {
  municipalities: Municipality[];
}

export const GET_MUNICIPALITIES_QUERY = gql`
  query MunicipalitiesResolver {
    municipalities {
      agsKey
      name
      taxRate
      sourceReferenceDate
    }
  }
`;

export const useMunicipalitiesQuery = (
  options?: QueryHookOptions<MunicipalitiesQueryResult>
) => useQuery<MunicipalitiesQueryResult>(GET_MUNICIPALITIES_QUERY, options);
